/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _title_fr = new IntlMessageFormat([{ type: 0, value: 'Édition du profil' }], 'fr');

export function title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title_fr.format(args) as unknown as string;
    }

    return _title_fr.format(args) as unknown as string;
}

const _edited_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vos modifications ont été enregistrées.' }],
    'fr',
);

export function edited(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _edited_fr.format(args) as unknown as string;
    }

    return _edited_fr.format(args) as unknown as string;
}

const _menu__sronly_toggle_menu_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ouvrir/Fermer le menu' }],
    'fr',
);

export function menu__sronly_toggle_menu(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__sronly_toggle_menu_fr.format(args) as unknown as string;
    }

    return _menu__sronly_toggle_menu_fr.format(args) as unknown as string;
}

const _menu__company_infos_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Informations' }],
    'fr',
);

export function menu__company_infos(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__company_infos_fr.format(args) as unknown as string;
    }

    return _menu__company_infos_fr.format(args) as unknown as string;
}

const _menu__photos_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Logo et bannière' }],
    'fr',
);

export function menu__photos(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__photos_fr.format(args) as unknown as string;
    }

    return _menu__photos_fr.format(args) as unknown as string;
}

const _menu__coordinates_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Coordonnées' }],
    'fr',
);

export function menu__coordinates(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__coordinates_fr.format(args) as unknown as string;
    }

    return _menu__coordinates_fr.format(args) as unknown as string;
}

const _menu__category_fr = new IntlMessageFormat([{ type: 0, value: 'Catégorie' }], 'fr');

export function menu__category(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__category_fr.format(args) as unknown as string;
    }

    return _menu__category_fr.format(args) as unknown as string;
}

const _menu__descriptions_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Descriptions' }],
    'fr',
);

export function menu__descriptions(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__descriptions_fr.format(args) as unknown as string;
    }

    return _menu__descriptions_fr.format(args) as unknown as string;
}

const _menu__planning_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Planning et Horaires' }],
    'fr',
);

export function menu__planning(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__planning_fr.format(args) as unknown as string;
    }

    return _menu__planning_fr.format(args) as unknown as string;
}

const _menu__profile_management_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Gestion de la fiche' }],
    'fr',
);

export function menu__profile_management(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__profile_management_fr.format(args) as unknown as string;
    }

    return _menu__profile_management_fr.format(args) as unknown as string;
}

const _menu__shopping_fr = new IntlMessageFormat([{ type: 0, value: 'Shopping' }], 'fr');

export function menu__shopping(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__shopping_fr.format(args) as unknown as string;
    }

    return _menu__shopping_fr.format(args) as unknown as string;
}

const _menu__managers_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Géstionnaires' }],
    'fr',
);

export function menu__managers(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__managers_fr.format(args) as unknown as string;
    }

    return _menu__managers_fr.format(args) as unknown as string;
}

const _menu__medias_fr = new IntlMessageFormat([{ type: 0, value: 'Médias' }], 'fr');

export function menu__medias(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__medias_fr.format(args) as unknown as string;
    }

    return _menu__medias_fr.format(args) as unknown as string;
}

const _menu__see_company_fiche_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Voir ma fiche' }],
    'fr',
);

export function menu__see_company_fiche(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__see_company_fiche_fr.format(args) as unknown as string;
    }

    return _menu__see_company_fiche_fr.format(args) as unknown as string;
}

const _menu__job_offers_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Mes annonces emploi' }],
    'fr',
);

export function menu__job_offers(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu__job_offers_fr.format(args) as unknown as string;
    }

    return _menu__job_offers_fr.format(args) as unknown as string;
}

const _create_job_offer_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Créer une annonce emploi' }],
    'fr',
);

export function create_job_offer(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _create_job_offer_fr.format(args) as unknown as string;
    }

    return _create_job_offer_fr.format(args) as unknown as string;
}

const _see_more_fr = new IntlMessageFormat([{ type: 0, value: 'Voir plus...' }], 'fr');

export function see_more(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _see_more_fr.format(args) as unknown as string;
    }

    return _see_more_fr.format(args) as unknown as string;
}

const _create_company_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Créer une société' }],
    'fr',
);

export function create_company(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _create_company_fr.format(args) as unknown as string;
    }

    return _create_company_fr.format(args) as unknown as string;
}

const _select_company_to_edit_fr = new IntlMessageFormat(
    [{ type: 0, value: "Choisissez l'entreprise à éditer:" }],
    'fr',
);

export function select_company_to_edit(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _select_company_to_edit_fr.format(args) as unknown as string;
    }

    return _select_company_to_edit_fr.format(args) as unknown as string;
}
